import { render, staticRenderFns } from "./MediaJury.vue?vue&type=template&id=3b558abd&scoped=true"
import script from "./MediaJury.vue?vue&type=script&lang=js"
export * from "./MediaJury.vue?vue&type=script&lang=js"
import style0 from "./MediaJury.vue?vue&type=style&index=0&id=3b558abd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b558abd",
  null
  
)

export default component.exports